import { inject, Injectable } from '@angular/core';
import { ShkDate } from 'shk-date';
import { ProfileService } from '../profile/profile.service';

export type DateFormat = 'YMD' | 'DMY' | 'MDY';
export type DateTimeFormat = 'HMS';

@Injectable({
	providedIn: 'root',
})
export class DateService {
	private readonly ProfileService = inject(ProfileService);

	formatDate(dateString: string): string {
		if (!dateString || dateString == '') return `N/A`;
		if (dateString.split(' ').length == 1) dateString += ` 00:00`;

		const shkDate = new ShkDate(new Date(dateString));
		shkDate.dateFormat = this.ProfileService.getDateFormat() as DateFormat;
		shkDate.timeFormat = this.ProfileService.getDateTimeFormat() as DateTimeFormat;
		shkDate.dateSeparator = '/';

		return `${shkDate.hours}:${shkDate.minutes}` == '00:00' ? `${shkDate.date}` : `${shkDate.date} ${shkDate.hours}:${shkDate.minutes}`;
	}

	formatDateForService(dateString: string): string {
		const shkDate = new ShkDate();
		shkDate.setDateFormat('YMD');
		shkDate.setTimeFormat('HMS');
		shkDate.setDate(dateString);
		return shkDate.dateTime;
	}

	getFirstOfWeek(): string {
		const now = new Date();
		const dayOfWeek = now.getDay();
		const diff = now.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
		const dateDiff = new Date(now.setDate(diff));
		return this.formatDateForService(dateDiff.toISOString());
	}

	getLastOfWeek(): string {
		const now = new Date();
		now.setHours(23, 59, 59, 999);
		const dayOfWeek = now.getDay();
		const diff = now.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1) + 6;
		return this.formatDateForService(new Date(now.setDate(diff)).toISOString());
	}

	getFirstOfMonth(): string {
		const now = new Date();
		const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
		return this.formatDateForService(firstOfMonth.toISOString());
	}

	getLastOfMonth(): string {
		const now = new Date();
		const lastOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
		return this.formatDateForService(lastOfMonth.toISOString());
	}

	getWeekRange(): { start: string; end: string } {
		return {
			start: this.getFirstOfWeek(),
			end: this.getLastOfWeek(),
		};
	}

	getMonthRange(): { start: string; end: string } {
		return {
			start: this.getFirstOfMonth(),
			end: this.getLastOfMonth(),
		};
	}
}
